import Dexie from 'dexie';
import { UserChatItem } from '../models/api/UserChatItem';
import { IMChat } from '../models/api/IMChat';
import { IMChatMsg } from '../models/app/IMChatMsg';
import { VChatMsg } from '../models/app/VChatMsg';

export class AppDatabase extends Dexie{

    vChats!: Dexie.Table<UserChatItem, string>
    vChatMsgs!: Dexie.Table<VChatMsg, number>
    chats!: Dexie.Table<IChat, string>
    chatMsgs!: Dexie.Table<IMChat, number>
    

    constructor(){
        super('AppDatabase')

        this.version(1).stores({
            vChats: 'chatId, recepUserId, lastChatTime',
            vChatMsgs: 'msgId, senderUid, msg, timeOfSending, dateOfSending',
            chats: 'chatterUid, lastMsgTime',
            chatMsgs: 'timestamp, senderUid, recepUid'
        })
    }

}


export interface IVChat{
    id: string,
    chatterId: string,
    chatterUid: string
    lastMsgId: number
}

export interface IVChatMsg{
    id: number
    fromUid: string
    msg: string
    timestamp: string
}

export interface IChat{
    chatterId: string
    chatterUid: string
    lastMsg?: IMChat
    lastMsgTime: string
    convStartTime: string
    unread: boolean
}

export interface IChatMsg{
    id: number
    fromUid: string
    msg: string
    img: string
    voice: string
    timestamp: string
}